<template>
	<div class="action-flow-node" style="height: 200px;">
		<div class="action-flow-title">Generate Document</div>
		<div class="action-flow-hint">Generate a document from a pre-defined template.</div>
		
		<ActionParamHint label="Template" hint="Document template to use. Templates can be configured in the Management menu in the sidebar." param-class="param-config"
			param-input-type="select"  param-input-label="Template" @param-change="handleParamChange"
			:param-input-options="[{ value: 'template1', label: 'Template 1' }, { value: 'template2', label: 'Template 2' }]"
			:param-input-value="parameters.template"
		/>
		<ActionParamHint label="Data" hint="Data to send to the template. You can feed in more than one object to this input." param-class="param-tgt"
			param-input-type="textarea"  param-input-label="Data" @param-change="handleParamChange"
			:param-input-value="parameters.data"
		/>
		<ActionParamHint label="File" hint="File created by this template." param-class="param-src" />
		
		<Handle type="target" id="tgt-data" :position="Position.Left" style="top: 135px;" />
		<Handle type="source" id="src-file" :position="Position.Right" style="top: 175px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	template: '',
	data: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			template: newNodeData.data?.template || '',
			data: newNodeData.data?.data || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

/*e.items = [
	{
		text: "Generate Report",
		icon: "docxfile",
		onItemClick: async () => {
			const blob = await DocTemplater.generateDocument(e.row.data);
			if (!blob) {
				notify({ message: "Document failed to generate correctly - please contact support.", type: "error", displayTime: 2000, position: "top right" });
				return;
			}
			notify({ message: "Document generated successfully - downloading.", type: "success", displayTime: 2000, position: "top right" });
			
			// Create download link and automatically trigger it.
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			const datestamp = new Date().toISOString().split('T')[0]; 		// Get YYYY-MM-DD
			link.download = `report-${e.row.data.id || 'generated'}-${datestamp}.docx`;
			document.body.appendChild(link);
			link.click();
			
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
		}
	},
];
import DocTemplater from '@/services/doctemplater';
*/
</script>
	